import NetworkService from "@shared/NetworkService";

const platformStatusApi = () => NetworkService.getClient('platform-status', {
    useDefaultEnhancers: false,
});

export const loadPlatformStatus = () => platformStatusApi().get('/api/status').then(res => res.data);
